import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M72.09 28.3301C77.54 35.1001 72.09 41.05 72.09 41.05C74.9 48.32 69.4501 52.7701 69.4501 52.7701C69.62 58.5501 65.49 66.1501 65.49 66.1501C65.49 66.1501 66.15 58.39 64.5 52.61C62.8 46.68 62.52 43.36 62.52 43.36C56.41 41.71 54.59 34.61 54.59 34.61C48.48 38.57 44.19 33.9501 44.19 33.9501C44.19 33.9501 39.57 40.56 32.3 39.73C26.96 39.12 25.2001 34.61 25.2001 34.61C21.2401 40.06 14.96 37.42 14.96 37.42C15.13 38.91 13.64 44.1901 11.66 51.4601C9.68005 58.7301 10.83 69.9601 10.83 69.9601C10.83 69.9601 7.03004 60.05 7.03004 52.29C7.03004 52.29 -1.71995 46.5101 3.73005 37.7601C3.73005 37.7601 -1.38997 30.8201 6.21003 24.8801C6.21003 24.8801 3.57006 17.94 10.1701 14.97C10.1701 14.97 11.0001 4.57002 21.7301 7.04002C21.7301 7.04002 24.37 0.760019 31.97 3.41002C31.97 3.41002 39.2401 -1.20995 45.5101 4.57005C45.5101 4.57005 54.59 1.76004 59.05 10.68C59.05 10.68 66.65 9.19002 67.47 16.79C67.47 16.79 71.27 17.1201 72.59 21.0801C73.91 25.0301 72.09 28.3301 72.09 28.3301Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
  )
}
